/**
 * Global Filters Selectors
 * Selectors for accessing global filter state
 */

import { createSelector } from '@reduxjs/toolkit';
import { GlobalFiltersState } from './globalFiltersSlice';

interface RootState {
  globalFilters: GlobalFiltersState;
}

const selectGlobalFiltersState = (state: RootState): GlobalFiltersState =>
  state.globalFilters;

export const selectSelectedOutletId = createSelector(
  [selectGlobalFiltersState],
  (filters) => filters.selectedOutletId,
);

export const selectGlobalSearch = createSelector(
  [selectGlobalFiltersState],
  (filters) => filters.globalSearch,
);

export const selectNotifications = createSelector(
  [selectGlobalFiltersState],
  (filters) => filters.notifications,
);

export const selectUnreadNotifications = createSelector(
  [selectNotifications],
  (notifications) => notifications.filter((n) => !n.read),
);

export const selectNotificationCount = createSelector(
  [selectGlobalFiltersState],
  (filters) => filters.notificationCount,
);
